import * as React from 'react';
import {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import useDrive from "../../hooks/useDrive";
import {DialogContent} from "@mui/material";
import FileService from "../../services/FileService";
import FilerobotImageEditor, {TABS, TOOLS} from "react-filerobot-image-editor";
import styles from "./image-editor-dialg.module.css";
import FileUpload from "../FileUpload";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
export default function ImageEditorDialog() {
    const {editorObject, changeEditorObject, CurrentDrive} = useDrive();
    const [downloadURL, setDownloadURL] = useState(null);
    const [droppedFile, setDroppedFile] = useState(new Blob());

    useEffect(() => {
        setDownloadURL('');
        if (editorObject && editorObject.type && editorObject.type === 'file') {
            getDownloadUrl();
        }
    }, [editorObject])

    const handleClose = () => {
        changeEditorObject(null);
    };
    const getDownloadUrl = async () => {
        const {parent, driveType} = CurrentDrive;
        const url = await FileService.getDownLoadLink(parent, editorObject.Key, driveType);
        if (url) {
            setDownloadURL(url.url || url);
        }

    }
    return (
        <div >
            <Dialog
                fullWidth={true}
                maxWidth={"md"}
                open={!!editorObject}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <DialogContent className={styles.dialogContentRoot}>
                    <div className={styles.root}>
                        {downloadURL && (
                            <FilerobotImageEditor
                                source={downloadURL}
                                onSave={(editedImageObject, designState) => {
                                    let {parent} = CurrentDrive;
                                    parent = parent === "" ? "/" : parent;
                                    // console.log(parent)
                                    editedImageObject.imageCanvas.toBlob(function (blob) {
                                        const file = new File([blob], editedImageObject.fullName);
                                        setDroppedFile(file)
                                        // DriveService.getS3BucketUrl({
                                        //     file_name: file.name,
                                        //     size: file.size,
                                        //     folder: parent
                                        // }).then(url => {
                                        //
                                        //     S3FileService.upload2(url, file, editedImageObject.mimeType, changeUploadProgress).then((uploadRes) => {
                                        //         // console.log(uploadRes);
                                        //         changeEditorObject(false);
                                        //         changeUploadStatus(UPLOAD_STATUS.UPLOADING);
                                        //         DriveService.getFileTree(parent).then(drive => {
                                        //             changeCurrentDrive({parent, drive});
                                        //             changeUploadStatus(UPLOAD_STATUS.DONE);
                                        //             addNotification({
                                        //                 type: 'success',
                                        //                 message: "Edited file uploaded successfully"
                                        //             });
                                        //         });
                                        //
                                        //     })
                                        // })

                                    });
                                }}
                                onClose={handleClose}
                                closeAfterSave={false}
                                annotationsCommon={{
                                    fill: '#ff0000',
                                }}
                                Text={{text: 'Smief...'}}
                                Crop={{
                                    presetsItems: [
                                        {
                                            titleKey: 'classicTv',
                                            descriptionKey: '4:3',
                                            ratio: 4 / 3,
                                            // icon: CropClassicTv, // optional, CropClassicTv is a React Function component. Possible (React Function component, string or HTML Element)
                                        },
                                        {
                                            titleKey: 'cinemascope',
                                            descriptionKey: '21:9',
                                            ratio: 21 / 9,
                                            // icon: CropCinemaScope, // optional, CropCinemaScope is a React Function component.  Possible (React Function component, string or HTML Element)
                                        },
                                    ],
                                    presetsFolders: [
                                        {
                                            titleKey: 'socialMedia', // will be translated into Social Media as backend contains this translation key
                                            // icon: Social, // optional, Social is a React Function component. Possible (React Function component, string or HTML Element)
                                            groups: [
                                                {
                                                    titleKey: 'facebook',
                                                    items: [
                                                        {
                                                            titleKey: 'profile',
                                                            width: 180,
                                                            height: 180,
                                                            descriptionKey: 'fbProfileSize',
                                                        },
                                                        {
                                                            titleKey: 'coverPhoto',
                                                            width: 820,
                                                            height: 312,
                                                            descriptionKey: 'fbCoverPhotoSize',
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }}
                                tabsIds={[TABS.ADJUST, TABS.ANNOTATE, TABS.WATERMARK, TABS.FINETUNE]} // or {['Adjust', 'Annotate', 'Watermark']}
                                defaultTabId={TABS.ANNOTATE} // or 'Annotate'
                                defaultToolId={TOOLS.TEXT} // or 'Text'
                            />
                        )}
                    </div>

                </DialogContent>
            </Dialog>
            { CurrentDrive
                ? <FileUpload parent={CurrentDrive.parent} droppedFile={droppedFile} hideUploadButton={true}/>
                : console.log("no parent", CurrentDrive) }
        </div>
    );
}
